import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

const SuratIjinRekapPage = () => {
  const navigate = useNavigate();
  
  // Dummy data for surat ijin
  const suratIjinData = [
    {
      id: 1,
      tanggal: '25 April 2025',
      kategori: 'Surat Ijin',
      subkategori: 'Sakit',
      status: 'Diterima'
    },
    {
      id: 2,
      tanggal: '20 April 2025',
      kategori: 'Surat Ijin',
      subkategori: 'Interupsi',
      status: 'Diterima'
    },
    {
      id: 3,
      tanggal: '15 April 2025',
      kategori: 'Laporan',
      subkategori: 'Kersos',
      status: 'Diproses'
    },
    {
      id: 4,
      tanggal: '10 April 2025',
      kategori: 'Laporan',
      subkategori: 'PSM',
      status: 'Diterima'
    },
    {
      id: 5,
      tanggal: '5 April 2025',
      kategori: 'Surat Ijin',
      subkategori: 'Tidak Masuk',
      status: 'Ditolak'
    },
    {
      id: 6,
      tanggal: '1 April 2025',
      kategori: 'Surat Ijin',
      subkategori: 'Interupsi',
      status: 'Diterima'
    },
    {
      id: 7,
      tanggal: '25 Maret 2025',
      kategori: 'Laporan',
      subkategori: 'PSM',
      status: 'Ditolak'
    },
    {
      id: 8,
      tanggal: '20 Maret 2025',
      kategori: 'Surat Ijin',
      subkategori: 'Pulang Awal',
      status: 'Diterima'
    },
    {
      id: 9,
      tanggal: '15 Maret 2025',
      kategori: 'Laporan',
      subkategori: 'Kompensasi',
      status: 'Diproses'
    },
    {
      id: 10,
      tanggal: '10 Maret 2025',
      kategori: 'Surat Ijin',
      subkategori: 'Tidak Masuk',
      status: 'Diterima'
    }
  ];
  
  return (
    <PageContainer>
      <PageHeader>
        <BackButton onClick={() => navigate('/rekap')}>
          <span>←</span> Kembali
        </BackButton>
        <h1>Rekap Surat Ijin</h1>
        <p>Riwayat permohonan ijin dan laporan</p>
      </PageHeader>
      
      <TableContainer>
        <DataTable>
          <thead>
            <tr>
              <th>No</th>
              <th>Tanggal</th>
              <th>Kategori</th>
              <th>Subkategori</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {suratIjinData.map((item, index) => (
              <tr key={item.id}>
                <td>{index + 1}</td>
                <td>{item.tanggal}</td>
                <td>{item.kategori}</td>
                <td>{item.subkategori}</td>
                <td>
                  <StatusBadge status={item.status.toLowerCase()}>
                    {item.status}
                  </StatusBadge>
                </td>
              </tr>
            ))}
          </tbody>
        </DataTable>
      </TableContainer>
    </PageContainer>
  );
};

const PageContainer = styled.div`
  padding: 1.5rem;
  max-width: 1280px;
  margin: 0 auto;
  
  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

const PageHeader = styled.div`
  margin-bottom: 2rem;
  position: relative;
  
  h1 {
    font-size: 1.75rem;
    font-weight: 600;
    color: var(--text-dark);
    margin-bottom: 0.5rem;
    text-align: center;
  }
  
  p {
    color: var(--text-light);
    text-align: center;
    font-size: 0.95rem;
  }
`;

const BackButton = styled.button`
  background: transparent;
  border: none;
  display: flex;
  align-items: center;
  color: var(--primary);
  font-weight: 500;
  cursor: pointer;
  padding: 0.5rem 0.75rem;
  margin-bottom: 1rem;
  border-radius: 4px;
  transition: all 0.2s ease;
  
  span {
    margin-right: 0.5rem;
    font-size: 1.2rem;
  }
  
  &:hover {
    background-color: var(--primary);
    color: white;
  }
`;

const TableContainer = styled.div`
  background-color: var(--background);
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
`;

const DataTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  
  th, td {
    padding: 1rem;
    text-align: left;
    border-bottom: 1px solid var(--border);
  }
  
  th {
    background-color: var(--background-light);
    font-weight: 600;
    color: var(--text-dark);
  }
  
  tr:last-child td {
    border-bottom: none;
  }
  
  tr:hover td {
    background-color: rgba(0, 0, 0, 0.01);
  }
  
  @media (max-width: 768px) {
    display: block;
    overflow-x: auto;
    
    th, td {
      padding: 0.75rem;
    }
  }
`;

const StatusBadge = styled.span`
  display: inline-block;
  padding: 0.35rem 0.75rem;
  border-radius: 1rem;
  font-size: 0.75rem;
  font-weight: 500;
  
  ${props => {
    switch(props.status) {
      case 'diterima':
        return `
          background-color: #e6f8f5;
          color: #00a389;
        `;
      case 'diproses':
        return `
          background-color: #fff3e0;
          color: #ff9800;
        `;
      case 'ditolak':
        return `
          background-color: #feeeee;
          color: #dc3545;
        `;
      default:
        return '';
    }
  }}
`;

export default SuratIjinRekapPage;